import { useContext } from "react";
import { NotificationContext } from "@/components/Notification";

export function useNotification() {
  return useContext(NotificationContext);
}
